<template>
  <div v-if="groupId != 20" >
    <spp-search :year="year"/>
  </div>
  <div v-else>
    <habitat-table />
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { sppSearchState } from '@/composables/state/speciesSearchApp';
import SppSearch from '../modules/speciesList/SppSearch.vue'
import HabitatTable from '../modules/habitatList/HabitatTable.vue'
export default {
  components: { SppSearch, HabitatTable },
  name: 'SpeciesPList',
  props: ['year'],
  setup (props) {
    const inGroupId = new URL(location.href).searchParams.get('groupId') || 1;
    const groupId = ref(inGroupId);

    onMounted(async () => {
      const { init } = sppSearchState();
      await init();
    });
    return {
      groupId
    }
  }
}
</script>
